import { QueryKeys } from '../../../queryKeys';
import { getRequest } from '../../../helpers/apiClient';
import apiRoutes from '../../../api-routes';
import { useQueryWithLogout } from '../../../hooks/useQueryWithLogout';

export const useFairUsage = (options) =>
  useQueryWithLogout(
    [QueryKeys.FAIR_USAGE],
    async () => {
      const { data } = await getRequest({
        url: apiRoutes.FAIR_USAGE,
      });
      return data;
    },
    options,
  );
